<template>
  <div
    v-if="config"
    class="header-projects-menu"
    :class="{
      'header-projects-menu--double-section': config.sections.length === 2,
    }"
  >
    <div
      v-for="(section, sectionIndex) in config.sections"
      :key="sectionIndex"
      class="header-projects-menu__section"
      :class="{
        'header-projects-menu__section--b2b': sectionIndex !== 0,
      }"
      :data-gtm-container="`header-menu-${sectionIndex === 0 ? 'b2c' : 'b2b'}`"
    >
      <h3 v-if="config.sections.length > 1" class="header-projects-menu__title">
        {{ section.title }}
      </h3>

      <ul class="header-projects-menu__links">
        <li v-for="link in section.links" :key="link.href">
          <SButton
            action-type="quaternary"
            fluid
            :href="link.href"
            :prefix-icon="link.icon"
            size="sm"
            text-align="left"
            @click="emit('clickProject')"
          >
            {{ link.label }}
          </SButton>
        </li>
      </ul>

      <div
        v-if="section.viewAllLink"
        class="header-projects-menu__bottom-links"
      >
        <SButton
          action-type="quaternary"
          color="primary"
          :href="section.viewAllLink.href"
          prefix-icon="fa-light fa-grid-2"
          size="sm"
          @click="emit('clickProject')"
        >
          {{ section.viewAllLink.label }}
        </SButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SButton } from "@solvari/common-fe";

import { useNavigation } from "./useNavigation";

const emit = defineEmits<{ clickProject: [] }>();

const { navigationConfig: config } = useNavigation();
</script>

<style lang="postcss">
.header-projects-menu {
  @apply grid grid-cols-1 px-8 py-6 gap-0;

  &--double-section {
    @apply grid-cols-[16fr,7fr];
  }

  &__section {
    @apply flex flex-col;
  }

  &--double-section &__section:first-child {
    @apply border-r border-slate-100 pr-8;
  }

  &__section--b2b {
    @apply pl-8;
  }

  &__title {
    @apply mb-3 text-base font-medium text-slate-900;
  }

  &__links {
    @apply m-0 grid list-none grid-flow-row grid-cols-3 grid-rows-[repeat(6,auto)] p-0 gap-x-6 gap-y-[1px];
  }

  &__section--b2b &__links {
    @apply flex grid-cols-none flex-col gap-0 gap-y-[1px];
  }

  &__bottom-links {
    @apply mt-4 border-t border-slate-100 pt-4;
  }
}
</style>
